import { useEffect } from "react"
import SponsorsLogos from "./svg/SponsorLogos"

function SponsorCollapse() { 
    const toggleCollapse = (e) => {
        // Don't toggle collapse if the user selected text
        var selection = window.getSelection();
        if(selection.toString()) {
            return;
        }

        // Don't toggle collapse if the user clicked on an <img> or <a> tag
        if (['A', 'IMG'].includes(e.target.tagName)) {
            return;
        }

        // Toggle opacity of map component in the background
        const mapWrapper = document.getElementById('react-map-wrapper')
        if (mapWrapper) {
            mapWrapper.classList.toggle('opacity-30')
        }

        // Add transition to collapse content
        const content = document.getElementById('collapse-content')
        content.style.transition = "opacity .6s, transform .8s ease-out"
    
        // Toggle collapse content
        if (content.classList.contains('opacity-0')) {
            content.classList.replace('opacity-0', 'opacity-1')
        }
        else {
            content.style.transform = 'translate(0)'
            content.classList.replace('opacity-1', 'opacity-0')
        }

        // Toggle selectability of text in collapse content
        content.classList.toggle('select-none')

        // Translate content
        translateContent()
        
        // Rotate chevron
        rotateChevron()
    }

    const translateContent = () => {
        const content = document.getElementById('collapse-content')
        
        if (content.classList.contains('opacity-1')) {
            // Calculate height of map: 
            // Height of window
            // - height of header    
            // - height of filters  
            // - height of footer
            // = 276px 
            const mapHeight = window.innerHeight - 276
            content.style.transform = 'translate(0px, ' + -mapHeight + 'px)'
            content.style.height = mapHeight + 'px'
        }
        else {
            content.style.transform = 'translate(0px, 200px)'
        }
    }

    const rotateChevron = () => {
        const chevron = document.getElementById('collapse-chevron')
        chevron.style.transition = 'transform .8s'
        chevron.classList.toggle('rotate-180')
    }

    useEffect(() => {
        // Initial translation of collapse content
        translateContent()

        // Also collapse whenever the window size changes        
        window.addEventListener('resize', translateContent)

        return () => {
            window.removeEventListener('resize', translateContent)
        }
    }, [])

    return (
        <div id="collapse-wrapper" className="flex-grow" onClick={toggleCollapse}>
            <div className="flex flex-row items-center justify-center">
                <button className="pr-1 select-none">Find out more about the startup map</button>
                <svg id="collapse-chevron" xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
            </div>
            <div id="collapse-content" className="opacity-1 absolute left-0 bottom-0 right-0 top-0 px-16 text-left text-base overflow-auto">
                <div className="text-sm flex items-center justify-between">
                    <h1 className="text-2xl">What is the Startup Map about?</h1>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeidth="2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>
                <div className="pt-2 pb-4 text-sm">
                Every startup & scaleup from the region can register on the startup map. Not only will they be visible with their business but also be part of the STATION Founders Community, which offers great benefits: Free Job Postings and Startup Portrait on STATION NEWS, Pulse Check Session, exclusive event invitations and more.
                </div>
                <h1 className="text-2xl">What is the Ecosystem Pulse Check?</h1>
                <div className="pt-2 pb-4 text-sm">
                We are keen to generate the best startup data for our region. Hence we developed our own tool and survey to do so: The Startup Ecosystem Pulse Check. Startups that registered on the map can automatically participate a Pulse Check Session. This helps us keep the content up-to-date, get to know you better and guide you in the right direction. By using the already registered profile data we minimize the time effort for founders. IMPORTANT NOTE: All data will be anonymized and personalized data will not be shared with any third party.
                </div>
                <h1 className="text-2xl">Feedback, Questions or Comments?</h1>
                <div className="pt-2 pb-4 text-sm">
                    Please write us: <a className="text-sm" href="mailto:redaktion@station-frankfurt.de ">redaktion@station-frankfurt.de</a>  
                </div>
                <div className="pt-6">
                    We thank our supporters:
                </div>
                <div className="pt-4 pb-4 flex-row justify-around">
                    <SponsorsLogos />
                    
                </div>
            </div>
        </div>
    )
}

export default SponsorCollapse
  